import { useEffect } from 'react';
/**
 * Set the browser title for the current page.
 *
 * Args:
 *   title: Plain-English page name without the brand suffix.
 */
export default function usePageTitle(title: string): void {
  useEffect(() => { document.title = `${title} · H2Okay`; }, [title]);
}
